import { without, flatMap, fromPairs } from 'lodash-es'

import Api from '@/api'
import { STATUS_5 } from '@/user'

export default {
  state: {
    resultsCount: 0,
    resultsLoading: false,
    categories: [],
    modalOpen: false,
    modalComponent: null,
    modalProps: null,
    isFilterOpen: false,
    searchProfile: null,
    sort: 'STANDARD'
  },
  mutations: {
    resultsCountSet (state, count) {
      state.resultsCount = count
    },
    resultsLoadingSet (state, loading) {
      state.resultsLoading = loading
    },
    modalOpen (state, { component, props }) {
      state.modalComponent = component
      state.modalProps = props
      state.modalOpen = true
    },
    modalClose (state) {
      state.modalComponent = null
      state.modalProps = null
      state.modalOpen = false
    },
    searchProfileAddTag (state, tagKey) {
      EventBus.trigger('filter-settings:add', { type: 'tag', key: tagKey })
      state.searchProfile.tagKeys = [...(new Set(state.searchProfile.tagKeys)).add(tagKey)]
      state.resultsLoading = true
    },
    searchProfileAddTags (state, tagKeys) {
      const set = new Set(state.searchProfile.tagKeys)

      tagKeys.forEach(tagKey => {
        EventBus.trigger('filter-settings:add', { type: 'tag', key: tagKey })
        set.add(tagKey)
      })

      state.searchProfile.tagKeys = [...set]
      state.resultsLoading = true
    },
    searchProfileRemoveCustomTag (state, tagKey) {
      EventBus.trigger('filter-settings:remove', { type: 'search-term', key: tagKey })
      state.searchProfile.customTags = without(state.searchProfile.customTags, tagKey)
      state.resultsLoading = true
    },
    searchProfileRemoveTag (state, tagKey) {
      EventBus.trigger('filter-settings:remove', { type: 'tag', key: tagKey })
      state.searchProfile.tagKeys = without(state.searchProfile.tagKeys, tagKey)
      state.resultsLoading = true
    },
    searchProfileRemoveTags (state, tagKeys) {
      tagKeys.forEach(tagKey => {
        EventBus.trigger('filter-settings:remove', { type: 'tag', key: tagKey })
      })

      state.searchProfile.tagKeys = without(state.searchProfile.tagKeys, ...tagKeys)
      state.resultsLoading = true
    },
    searchProfileClear (state) {
      state.searchProfile.tagKeys.forEach(tagKey => {
        EventBus.trigger('filter-settings:remove', { type: 'tag', key: tagKey })
      })
      state.searchProfile.customTags.forEach(tagKey => {
        EventBus.trigger('filter-settings:remove', { type: 'search-term', key: tagKey })
      })

      state.resultsLoading = true
      state.searchProfile.tagKeys = []
      state.searchProfile.customTags = []
    },
    filterOpen (state) {
      state.isFilterOpen = true
    },
    filterClose (state) {
      state.isFilterOpen = false
    },
    filterToggle (state) {
      state.isFilterOpen = !state.isFilterOpen
    },
    sortSet (state, newSort) {
      EventBus.trigger('filter-settings:sort', newSort)
      state.sort = newSort
    }
  },
  actions: {
    setupLegacy ({ state, getters, commit }) {
      getters.checkedTags.forEach(tag => {
        EventBus.trigger('filter-settings:add', { type: 'tag', key: tag.key })
      })
      state.searchProfile.customTags.forEach(tag => {
        EventBus.trigger('filter-settings:add', { type: 'search-term', key: tag })
      })
      EventBus.trigger('filter-settings:setup-complete', null)
      EventBus.on('filter-settings:results-count', (_event, count) => {
        commit('resultsCountSet', count)
        commit('resultsLoadingSet', false)
      })
    },
    searchProfileSave ({ state, getters }, { apiUrl }) {
      if (getters.isUserStatus(STATUS_5)) {
        return Api.saveSearch(apiUrl, state.searchProfile).then(data => {
          EventBus.trigger('snackbar:message', {
            body: data,
            handlers: []
          })
        })
      } else {
        return Api.postSaveSearch(apiUrl, state.searchProfile)
      }
    }
  },
  getters: {
    isUserStatus: ({ user }) => (status) => {
      return user && user.status === status
    },
    flatTagMap ({ categories }) {
      return fromPairs(flatMap(categories, category => {
        return flatMap(category.grouped_category_tags, group => {
          return group.group_tags.map(tag => [tag.key, tag])
        })
      }))
    },
    checkedTagsMap (_state, { checkedTags }) {
      return (checkedTags && fromPairs(checkedTags.map(tag => [tag.key, tag]))) || {}
    },
    checkedTags ({ searchProfile }, { flatTagMap }) {
      return (searchProfile && searchProfile.tagKeys.map(tagKey => flatTagMap[tagKey])) || []
    }
  }
}
